import { render, staticRenderFns } from "./PluginItemListOverview.vue?vue&type=template&id=2ec53d90&scoped=true"
import script from "./PluginItemListOverview.vue?vue&type=script&lang=js"
export * from "./PluginItemListOverview.vue?vue&type=script&lang=js"
import style0 from "./PluginItemListOverview.vue?vue&type=style&index=0&id=2ec53d90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec53d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec53d90')) {
      api.createRecord('2ec53d90', component.options)
    } else {
      api.reload('2ec53d90', component.options)
    }
    module.hot.accept("./PluginItemListOverview.vue?vue&type=template&id=2ec53d90&scoped=true", function () {
      api.rerender('2ec53d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginItemListOverview.vue"
export default component.exports